export default __webpack_public_path__ + "static/media/elena-site-logo-558 x 106.1f0a3dd8.jpg";